import React, { useEffect, useState } from "react";
import "./style.css";
import { useDispatch } from "react-redux";
import { UIColor } from "../../themes/theme";
import { AxiosCall, urls, AlertProps, __tenantid__ } from "../../utils";
import { getSize } from "../../screens/patientRegistration/components/handlers";
import jwtDecode from "jwt-decode";
import axios from "axios";
import {
  Stack,
  Typography,
  Dialog,
  Chip,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
  Autocomplete,
  TextField,
  IconButton,
} from "@mui/material";
import { AlertContext } from "../../context";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../router/routes";
import dayjs from "dayjs";
import AppHeader from "../layout/appHeader";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import CloseIcon from "@material-ui/icons/Close";
import actions from "../../redux/actions";

var debouncing;

const PicReviewSheet = (props) => {
  const dispatch = useDispatch();
  const alert = useContext(AlertContext);
  const userInfo = localStorage.getItem("UserInfo");
  const decodedUserinfo = jwtDecode(userInfo);
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [reportsData, setReportsData] = useState({
    facility: [],
    startdate: "",
    patient: [],
  });
  const [facilityNameData, setFacilityNameData] = useState([]);
  const [defaultFacilityValue, setDefaultFacilityValue] = useState([]);
  const [initialLoad, setInitialLoad] = React.useState(true);
  const [patientNameData, setPatientNameData] = useState([]);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [error, setError] = useState({});
  const { parent_id } = props;

  const setData = async (name, value) => {
    const updatedData = { ...reportsData };
    if (name === "startdate") {
      updatedData[name] = dayjs(value).format("YYYY-MM-01");
    } else {
      updatedData[name] = value;
    }
    setReportsData(updatedData);
  };

  const GetPractID = (data) => {
    let list = [];

    for (let index in data) {
      const item = data[index];
      const datatemp = {
        value: item.name,
        _id: item.id,
      };
      list.push(datatemp);
    }
    return list;
  };
  const GetFacilityId = (data) => {
    let list = [];

    for (let index in data) {
      const item = data[index];
      const datatemp = {
        value: item.name,
        _id: item._id,
      };

      list.push(datatemp);
    }
    return list;
  };

  const validation = () => {
    let data = {
      facility: [],
      startdate: "",
    };
    let validation = {
      error: false,
    };

    Object.keys(data).forEach((v) => {
      if (v === "startdate") {
        if (reportsData[v] == null && reportsData[v] == undefined) {
          validation.error = true;
          validation[v] = true;
        } else {
          if (!dayjs(reportsData[v]).isValid()) {
            validation.error = true;
            validation[v] = true;
          } else {
            validation[v] = false;
          }
        }
      } else if (Array.isArray(data[v])) {
        if (!reportsData[v]?.length) {
          validation.error = true;
          validation[v] = true;
        } else {
          validation[v] = false;
        }
      }
    });
    setError(validation);
    return validation;
  };
  const dailogclose = () => {
    setOpen(false);
    navigate(AppRoutes.dashboard);
  };

  const HandleChangeForUser = (e, v) => {
    setReportsData({ ...reportsData, patient: v || [] });
  };
  const ServcieSearch = (value) => {
    if (value) {
      clearTimeout(debouncing);
      debouncing = setTimeout(() => {
        dispatch(actions.REPORTS_FACILITY_DROPDOWN(value));
      }, 700);
    }
  };
  const UserSearch = (value) => {
    if (value) {
      clearTimeout(debouncing);
      debouncing = setTimeout(() => {
        dispatch(actions.Pic_Review_Sheet_Practitioner_DropDown(value));
      }, 700);
    }
  };

  const facilityName = async () => {
    const response = await dispatch(
      actions.REPORTS_FACILITY_DROPDOWN({
        facilityid: decodedUserinfo?.facilityid || "",
        tenantid: decodedUserinfo?.tenantid,
      })
    );
    setFacilityNameData(response?.payload?.data);
    const defaultFacility = response?.payload?.data.filter(
      (item) => item?._id === decodedUserinfo?.facilityid
    );
    setDefaultFacilityValue(defaultFacility)
    // setReportsData((prevState) => ({
    //   ...prevState,
    //   facility: [
    //     {
    //       value: defaultFacility?.[0]?.name,
    //       _id: defaultFacility?.[0]?._id,
    //     },
    //   ],
    //   startdate: dayjs().format("YYYY-MM-01"),
    // }));
  };
  const practitionerName = async () => {
    const response = await dispatch(
      actions.Pic_Review_Sheet_Practitioner_DropDown({
        orgid: decodedUserinfo?.facilityid || "",
      })
    );
    setPatientNameData(response?.payload?.data);
  };

  useEffect(() => {
    facilityName();
    practitionerName();
  }, []);
  const generateAndOpenJasperReport = async () => {
    const getEpochTime = (date) => Math.floor(date.getTime() / 1000);
    let JwtToken = localStorage.getItem("JwtToken");
    let header = { JwtToken: JwtToken };

    const startDate = new Date(reportsData?.startdate);
    startDate.setHours(0, 0, 0, 0);
    const startEpochTime = getEpochTime(startDate);

    let valid = validation();
    if (valid.error) {
      alert?.setSnack({
        open: true,
        severity: AlertProps.severity.warning,
        msg: "Please fill mandatory fields",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.center,
        tone: true,
      });
      return;
    } else {
      const payload = {
        reportid: "fca764a3-d0a7-4fcc-863f-e179d0d3d60c",
        inputparams: {
          "@facilityid":
            reportsData?.facility?.map((item) => item._id).join(",") ?? "",
          "@practitionerid":
            reportsData?.patient?.map((item) => item._id).join(",") ?? "",
          "@startofmonth": startEpochTime,
        },
  
        result: [],
      };
      AxiosCall("post", urls.jasperReport, payload, header).then(
        async (res) => {
          if (res?.downloadUrl) {
            const response = await axios.get(res?.downloadUrl, {
              method: "GET",
              responseType: "blob",
            });
            const pdfBlob = new Blob([response.data], {
              type: "application/pdf",
            });
            const pdfDataUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfDataUrl, "_blank");
            props?.handleModalClose();
          } else {
            alert?.setSnack({
              open: true,
              severity: AlertProps.severity.error,
              msg: "There is no report available.",
              vertical: AlertProps.vertical.top,
              horizontal: AlertProps.horizontal.center,
              tone: true,
            });
            props?.handleModalClose();
          }
        }
      );
    }
    setOpen(false);
    navigate(AppRoutes.dashboard);
  };
  useEffect(() => {
    if (downloadUrl) {
      const downloadLink = document.createElement("a");
      downloadLink.href = downloadUrl;
      downloadLink.target = "_blank";
      downloadLink.download = "report.pdf";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }, [downloadUrl]);
  const helperTextMsg = "This field is required!";
  const errorMessage = React.useMemo(() => {
    if (error?.startdate || error?.enddate) {
      return "Please select a date";
    }
  }, [error]);
  const getPractitionerById = (id) => {
    const practitionerById = patientNameData.find((item) => item.id === id);
    if (practitionerById) {
      return { id: practitionerById?.id, name: practitionerById?.name };
    }
  };
  const loadPractitionerById = 
  getPractitionerById(decodedUserinfo?.practitionerid) 
  ? getPractitionerById(decodedUserinfo?.practitionerid) 
  : patientNameData?.length === 1 
    ? patientNameData : null;

  useEffect(() => {
    if (defaultFacilityValue||patientNameData&&initialLoad) {
        setReportsData((prevState) => ({
            ...prevState,
            facility: [
                {
                  value: defaultFacilityValue?.[0]?.name,
                  _id: defaultFacilityValue?.[0]?._id,
                },
            ],
            startdate: dayjs().format("YYYY-MM-01"),
            patient:loadPractitionerById ? [
              {
              value: loadPractitionerById?.[0]?.name,
              _id: loadPractitionerById?.[0]?.id,
            },
          ] : "",
        }));
        setInitialLoad(false);
    }
}, [defaultFacilityValue,patientNameData,initialLoad]);
  return (
    <div>
      {/* <Grid>
        <AppHeader />
      </Grid> */}
      {/* <Dialog
        maxWidth="xl"
        fullWidth
        open={open}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DialogTitle>
          <Typography style={{ fontSize: "18px" }}>
            PIC Review Sheet Report
          </Typography>
        </DialogTitle>
        <DialogContent dividers> */}
          <div
            style={{
              backgroundColor: "#fff",
              outline: "none",
              width: 500,
              padding: "10px",
            }}
          >
            <IconButton
          aria-label="close"
          onClick={props?.handleModalClose}
          style={{ position: "absolute", right: 0, top: 0 }}
        >
          <CloseIcon />
        </IconButton>
            <Grid container spacing={2}>
            <Grid
                item
                id={`${parent_id}referral_parent_Referring_from_Facility_col`}
                md={12}
                lg={12}
                sm={12}
                xs={12}
                className="no-padding-left"
                inLineStyles={{ padding: 10 }}
              >
                <Typography variant="h5">PIC Review Sheet Report</Typography>
              </Grid>
              <Grid
                item
                id={`${parent_id}referral_parent_Referring_from_Facility_col`}
                md={12}
                lg={12}
                sm={12}
                xs={12}
                className="no-padding-left"
                inLineStyles={{ padding: 10 }}
              >
                <div>
                  <Autocomplete
                    multiple
                    id="tags-filled"
                    options={GetFacilityId(facilityNameData) ?? []}
                    getOptionLabel={(option) => option?.value ?? ""}
                    limitTags={2}
                    hoverColor={UIColor.primaryColor.color}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option?.value}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        required={true}
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder="search facility"
                        label="Facility"
                        hoverColor={UIColor.primaryColor.color}
                        sx={{
                          "& .MuiAutocomplete-inputRoot": {
                            borderRadius: "8px",
                            border: "1px  #E0E0E0",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                        }}
                        error={error?.facility}
                        helperText={error?.facility ? helperTextMsg : ""}
                      />
                    )}
                    onChange={(event, newValue) =>
                      setData("facility", newValue)
                    }
                    value={reportsData?.facility || []}
                    onInputChange={(e) => {
                      ServcieSearch(e.target.value);
                    }}
                  />
                </div>
              </Grid>
              <Grid
                item
                id={`${parent_id}referral_parent_Date_of_Referral_In_col`}
                md={12}
                lg={12}
                sm={12}
                xs={12}
                className="no-padding-left"
                inLineStyles={{ padding: 10 }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Month & Year"
                    value={
                      reportsData?.startdate
                        ? dayjs(reportsData?.startdate)
                        : dayjs()
                    }
                    views={["month", "year"]}
                    onChange={(date) => setData("startdate", date)}
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderRadius: "8px",
                        },
                      },
                    }}
                    slotProps={{
                      textField: {
                        helperText: errorMessage,
                        error: error?.startdate ? true : false,
                        size: "small",
                        fullWidth: true,
                        required: true,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                item
                id={`${parent_id}referral_parent_Referring_from_Facility_col`}
                md={12}
                lg={12}
                sm={12}
                xs={12}
                className="no-padding-left"
                inLineStyles={{ padding: 10 }}
              >
                <div>
                  <Autocomplete
                    multiple
                    id="tags-filled"
                    options={GetPractID(patientNameData) ?? []}
                    getOptionLabel={(option) => option?.value ?? ""}
                    limitTags={2}
                    hoverColor={UIColor.primaryColor.color}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option?.value}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder="search practitioner"
                        hoverColor={UIColor.primaryColor.color}
                        style={{ paddingBottom: "20px" }}
                        sx={{
                          "& .MuiAutocomplete-inputRoot": {
                            borderRadius: "8px",
                            border: "1px  #E0E0E0",
                          },
                        }}
                        label="Practitioner"
                        InputProps={{
                          ...params.InputProps,
                        }}
                      />
                    )}
                    onChange={(e, v) => {
                      HandleChangeForUser(e, v);
                    }}
                    value={reportsData?.patient || []}
                    onInputChange={(e) => {
                      UserSearch(e.target.value);
                    }}
                  />
                </div>
              </Grid>
            </Grid>

            <Stack
              container
              md={12}
              lg={12}
              spacing={3}
              direction="row"
              justifyContent="center"
            >
              <Button
                variant="outlined"
                size="medium"
                style={{
                  color: UIColor.primaryColor.color,
                  borderColor: UIColor.primaryColor.color,
                }}
                onClick={props?.handleModalClose}
              >
                Cancel
              </Button>

              <Button
                size="medium"
                style={{
                  color: "#fff",
                  background: UIColor.primaryColor.color,
                }}
                variant="contained"
                onClick={() => generateAndOpenJasperReport()}
              >
                Submit
              </Button>
            </Stack>
          </div>
        {/* </DialogContent>
      </Dialog> */}
    </div>
  );
};

export default PicReviewSheet;
